import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ClienteService extends BaseService {
  constructor() {
    super(`${ConfigApi.usuarioURL}`);
    this.filter = new Filter();
  }

  getFilter() {
    return this.filter;
  }

  setFilter(filter) {
    this.filter = filter;
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.email = '';
    this.idContabilidade = 0;
    this.idCliente = 0;
    this.limit = 11;
    this.page = 0;
  }
}
export default new ClienteService();
